<button
  class="basemap-toggle"
  [class.active]="expanded()"
  (click)="toggle()"
  [title]="expanded() ? 'Collapse' : 'Expand'"
  [attr.aria-expanded]="expanded()"
  aria-label="Toggle basemap selector"
>
  <!-- Matches the collapse affordance of Esri's Expand widget, which this
       component replaced in the v5 upgrade: the basemap glyph becomes a
       ">>" collapse chevron while the list is open (JMKW-1876). -->
  <span
    class="esri-icon"
    [class.esri-icon-basemap]="!expanded()"
    [class.esri-icon-collapse]="expanded()"
    aria-hidden="true"
  ></span>
</button>
@if (expanded()) {
  <ul class="basemap-list" role="listbox" aria-label="Basemaps">
    @for (basemap of basemaps(); track basemap.id) {
      <li role="option" [attr.aria-selected]="currentBasemap()?.id === basemap.id">
        <button
          class="basemap-item"
          [class.active]="currentBasemap()?.id === basemap.id"
          (click)="selectBasemap(basemap)"
        >
          {{ basemap.title }}
        </button>
      </li>
    }
  </ul>
}
